import React from 'react';
import { EquipmentAttachment } from '../../../../model/equipment-attachment';
import { entityManagerProvider } from '../../../../model/entity-manager-provider';
import { EntityManager, EntityQuery } from 'breeze-client';
import moment from 'moment';
import { Card, Table } from 'react-bootstrap';
import { Loader } from '@progress/kendo-react-indicators';
import { EquipmentAttachmentType } from '../../../../model/equipment-attachment-type';
import ImgPlaceHolder from './document-logo.jpg';
import { projectStorage } from '../../../../../firebase/Config';
// import { Upload } from '@progress/kendo-react-upload';
interface EquipmentAttachmentList {
  equipmentAttachment: EquipmentAttachment[];
  equipmentAttachmentTypes: EquipmentAttachmentType[];
  selected: EquipmentAttachment;
  ids: number;
  loading: boolean;
  allowAdd: boolean;
  attFile: any;
}

class EquipmentAttachments extends React.Component<
  any,
  EquipmentAttachmentList
> {
  manager: EntityManager;
  conditions: String[];
  constructor(props) {
    super(props);
    this.state = {
      equipmentAttachment: [] as EquipmentAttachment[],
      equipmentAttachmentTypes: [] as EquipmentAttachmentType[],
      selected: null as EquipmentAttachment,
      ids: 0 as number,
      loading: true,
      allowAdd: true,
      attFile: null,
    };
    this.manager = entityManagerProvider.newManager();
    this.saveChanges = this.saveChanges.bind(this);
    this.rejectChanges = this.rejectChanges.bind(this);
    this.addEquipmentAttachment = this.addEquipmentAttachment.bind(this);
    this.remove = this.remove.bind(this);
    this.setTypeState = this.setTypeState.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.conditions = ['.img', '.jpg', '.jpeg'];
  }

  componentDidMount() {
    entityManagerProvider.subscribeComponent(this.manager, this);

    const query = new EntityQuery('EquipmentAttachments')
      .where('equipmentId', 'equals', this.props.currentProductId)
      .expand('equipmentAttachmentType, applicationUser');
    const queryEquipmentAttachmentType = new EntityQuery(
      'EquipmentAttachmentTypes'
    );
    this.manager.executeQuery(queryEquipmentAttachmentType).then((qr) => {
      this.setState({
        equipmentAttachmentTypes: qr.results,
      });
    });
    this.manager.executeQuery(query).then((qr) => {
      this.setState({
        selected: null,
        equipmentAttachment: qr.results,
        loading: false,
      });
    });
  }
  componentWillUnmount() {
    entityManagerProvider.unsubscribeComponent(this.manager, this);
  }

  addEquipmentAttachment() {
    this.setState({
      ids: this.state.ids - 1,
      allowAdd: false,
    });
    let equipmentAttachment = this.manager.createEntity(
      EquipmentAttachment.prototype.entityType,
      {
        equipmentAttachmentId: this.state.ids,
        applicationUserId: this.props.authorizedUser.Id,
        createdOn: new Date(),
        modifiedOn: new Date(),
        equipmentId: this.props.currentProductId,
      }
    ) as EquipmentAttachment;
    // select the new customer, and add it to the list of customers
    this.setState({
      selected: equipmentAttachment,
      equipmentAttachment: this.state.equipmentAttachment.concat([
        equipmentAttachment,
      ]),
    });
  }

  remove(ent: EquipmentAttachment) {
    ent.entityAspect.setDeleted();
    this.saveChanges();
  }
  dateFormatter(cell) {
    if (!cell) {
      return '';
    }
    return `${
      moment(cell).format('DD-MM-YYYY')
        ? moment(cell).format('DD-MM-YYYY')
        : moment(cell).format('DD-MM-YYYY')
    }`;
  }

  isPaidString(isPaid) {
    if (isPaid) {
      return 'Paid';
    }
    return 'Not Paid';
  }
  saveChanges() {
    this.setState({
      loading: true,
    });
    if (this.state.attFile) {
      const uploadPath = `equipmentattachments/${this.props.currentProductId}/${this.state.attFile.name}`;
      projectStorage
        .ref(uploadPath)
        .put(this.state.attFile)
        .then((res) => {
          res.ref.getDownloadURL().then((attUrl) => {
            let selectedEquipment = this.state.selected;
            selectedEquipment.attachmentUrl = attUrl;
            this.setState({
              selected: selectedEquipment,
            });
            this.manager
              .saveChanges()
              .then(() => {
                // refresh customer list to remove deleted customers
                this.setState({
                  selected: null,
                  equipmentAttachment: this.manager.getEntities(
                    'EquipmentAttachment'
                  ) as EquipmentAttachment[],
                });
              })
              .catch((error) => {
                this.setState({
                  selected: null,
                  equipmentAttachment: this.manager.getEntities(
                    'EquipmentAttachment'
                  ) as EquipmentAttachment[],
                });
                console.log('error catch', error, error.entityErrors);
              })
              .finally(() => {
                this.setState({
                  loading: false,
                  selected: null,
                  allowAdd: true,
                });
              });
          });
        });
    } else {
      this.manager
        .saveChanges()
        .then(() => {
          // refresh customer list to remove deleted customers
          this.setState({
            selected: null,
            equipmentAttachment: this.manager.getEntities(
              'EquipmentAttachment'
            ) as EquipmentAttachment[],
          });
        })
        .catch((error) => {
          this.setState({
            selected: null,
            equipmentAttachment: this.manager.getEntities(
              'EquipmentAttachment'
            ) as EquipmentAttachment[],
          });
          console.log('error catch', error, error.entityErrors);
        })
        .finally(() => {
          this.setState({
            loading: false,
            selected: null,
            allowAdd: true,
          });
        });
    }
  }

  rejectChanges() {
    this.manager.rejectChanges();
    // refresh customer list to restore original state
    let productAtts = this.manager.getEntities(
      'EquipmentAttachment'
    ) as EquipmentAttachment[];
    productAtts = productAtts.sort(
      (a, b) => a.equipmentAttachmentId - b.equipmentAttachmentId
    );
    this.setState({
      selected: null,
      equipmentAttachment: productAtts,
      allowAdd: true,
    });
  }
  handleFileChange(event, equipmentAttachment) {
    equipmentAttachment.attachmentUrl = null;
    this.setState({
      attFile: null,
    });
    let selectedFile = event.target.files[0];
    if (selectedFile) {
      this.setState({
        attFile: selectedFile,
      });
    }
  }
  renderPaymentEdit() {
    let equipmentAttachment = this.state.selected;
    function handleCatChange(event) {
      equipmentAttachment.equipmentAttachmentTypeId = event.target.value;
    }

    if (equipmentAttachment) {
      return (
        <div>
          <Card border="primary" style={{ width: '100%' }}>
            <Card.Header>
              <button
                className="btn btn-primary ml-2"
                type="button"
                disabled={
                  !this.manager.hasChanges() ||
                  !this.state.selected?.equipmentAttachmentTypeId
                }
                onClick={this.saveChanges}
              >
                <i className="fa fa-save"></i>
                Save Changes
              </button>
              <button
                className="btn btn-primary ml-2"
                type="button"
                disabled={!this.manager.hasChanges()}
                onClick={this.rejectChanges}
              >
                <i className="fa fa-redo"></i>
                Revert Changes
              </button>
              <button
                className="btn btn-danger ml-2"
                type="button"
                onClick={this.remove.bind(this, equipmentAttachment)}
              >
                <i className="fa fa-trash"></i>
                Delete
              </button>
            </Card.Header>
            <Card.Body>
              <form>
                <div className="form-group row">
                  <div className="col-lg-4">
                    <label>Name</label>
                    <input
                      className="form-control"
                      type="text"
                      name="attName"
                      value={equipmentAttachment.attName || ''}
                      onChange={equipmentAttachment.handleChange}
                    />
                  </div>
                  <div className="col-lg-4">
                    <label>Reference</label>
                    <input
                      className="form-control"
                      type="text"
                      name="attRef"
                      value={equipmentAttachment.attRef || ''}
                      onChange={equipmentAttachment.handleChange}
                    />
                  </div>

                  <div className="col-lg-4">
                    <label>Type</label>
                    <select
                      className="form-control"
                      name="equipmentAttachmentTypeId"
                      onChange={handleCatChange}
                      value={equipmentAttachment.equipmentAttachmentTypeId || 0}
                    >
                      <option key={0} value={0}>
                        Select Type
                      </option>
                      {this.state.equipmentAttachmentTypes?.map((type) => {
                        return (
                          <option
                            key={type.equipmentAttachmentTypeId}
                            value={type.equipmentAttachmentTypeId}
                          >
                            {type.attTypeName}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="col-lg-12">
                    <label>Attachment</label>
                    <input
                      className="form-control"
                      type="file"
                      onChange={(e) =>
                        this.handleFileChange(e, equipmentAttachment)
                      }
                    />
                    {equipmentAttachment.attachmentUrl &&
                    this.conditions.some((a) =>
                      equipmentAttachment.attachmentUrl.includes(a.toString())
                    ) ? (
                      <>
                        <a
                          href={equipmentAttachment.attachmentUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={equipmentAttachment.attachmentUrl}
                            alt={equipmentAttachment.attName}
                            style={{ maxHeight: '100px' }}
                          />
                        </a>
                      </>
                    ) : (
                      <>
                        {equipmentAttachment.attachmentUrl ? (
                          <a
                            href={equipmentAttachment.attachmentUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={ImgPlaceHolder}
                              alt={equipmentAttachment.attName}
                              style={{ maxHeight: '100px' }}
                            />
                          </a>
                        ) : (
                          <span>No Attachment</span>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </form>
            </Card.Body>
          </Card>
        </div>
      );
    }
  }

  setTypeState(type: EquipmentAttachment) {
    this.rejectChanges();
    this.setState({ selected: type });
  }
  render() {
    return (
      <div className="card card-custom card-stretch">
        <div className="card-header py-3">
          <div className="card-title align-items-start flex-column">
            <h3 className="card-label font-weight-bolder text-dark">
              EquipmentAttachments
            </h3>
            <span className="text-muted font-weight-bold font-size-sm mt-1">
              e.g. Custom, Loading , Shipment ...
            </span>
          </div>
          <div className="card-toolbar">
            <button
              type="submit"
              className="btn btn-success mr-2"
              onClick={this.addEquipmentAttachment}
              disabled={!this.state.allowAdd}
            >
              Add EquipmentAttachment
            </button>
            <button
              type="submit"
              className="btn btn-warning mr-2"
              onClick={() => {
                this.setState({ selected: null, allowAdd: true });
              }}
            >
              Cancel
            </button>
          </div>
        </div>
        <div className="card-body">
          {this.state.loading ? (
            <div className="row" style={{ minHeight: '200px' }}>
              <Loader
                size="large"
                style={{ position: 'relative', margin: '60px auto' }}
                type="converging-spinner"
              />
            </div>
          ) : (
            <div className="row">
              <div className="col-xl-6">
                <div style={{ overflow: 'scroll', height: '600px' }}>
                  <Table className="table" bordered responsive="sm">
                    <thead>
                      <tr>
                        <th>Type</th>
                        <th>Name</th>
                        <th>Reference</th>
                        <th>File</th>
                        <th>Created</th>
                        <th>User</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.equipmentAttachment?.map((type, idx) => {
                        return (
                          <tr
                            key={type.equipmentAttachmentId}
                            style={{
                              backgroundColor:
                                type === this.state.selected
                                  ? 'lightgray'
                                  : 'white',
                            }}
                            onClick={() => this.setTypeState(type)}
                          >
                            <td>{type.equipmentAttachmentType?.attTypeName}</td>
                            <td>{type.attName}</td>
                            <td>{type.attRef}</td>
                            <td>
                              {type.attachmentUrl &&
                              this.conditions.some((a) =>
                                type.attachmentUrl.includes(a.toString())
                              ) ? (
                                <img
                                  src={type.attachmentUrl}
                                  alt={type.attName}
                                  style={{ maxHeight: '100px' }}
                                />
                              ) : (
                                <>
                                  {type.attachmentUrl ? (
                                    <img
                                      src={ImgPlaceHolder}
                                      alt={type.attName}
                                      style={{ maxHeight: '100px' }}
                                    />
                                  ) : (
                                    <span>No Attachment</span>
                                  )}
                                </>
                              )}
                            </td>
                            <td>{this.dateFormatter(type.modifiedOn)}</td>
                            <td>{type.applicationUser?.fullName}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              </div>
              <div className="col-xl-6">
                {/* {this.state.selected && <AttachmentUpload handleFileChange={this.handleFileChange}/>} */}
                {this.renderPaymentEdit()}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default EquipmentAttachments;
